(() => {
 'use strict';
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 let ticking = false;
 const progress = () => { ticking = false; const travel = document.documentElement.scrollHeight - innerHeight; document.documentElement.style.setProperty('--ad-progress', travel > 0 ? Math.min(1,scrollY/travel) : 0); };
 addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(progress); } }, {passive:true});
 addEventListener('resize', progress, {passive:true});
 function init(root=document) {
   root.querySelectorAll('.ad-room').forEach(room => {
     if(room.dataset.adReady) return;
     room.dataset.adReady='true';
     const select=room.querySelector('[data-st-motif]'), buttons=[...room.querySelectorAll('[data-ad-motif]')];
     if(!select) return;
     const sync=()=>buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.adMotif===select.value)));
     buttons.forEach(b=>b.addEventListener('click',()=>{select.value=b.dataset.adMotif;select.dispatchEvent(new Event('change',{bubbles:true}));sync();}));
     room.addEventListener('click',e=>{if(e.target.closest('[data-st-position],[data-st-slot]')) requestAnimationFrame(sync);});
     sync();
   });
   root.querySelectorAll('.ad-reveal').forEach(el=> {
     if(el.dataset.adSeen||reduced.matches||!('IntersectionObserver' in window))return;
     el.dataset.adSeen='true';
     const observer=new IntersectionObserver(entries=> { if(entries.some(e=>e.isIntersecting)){el.animate([{opacity:.3,transform:'translateY(22px)'},{opacity:1,transform:'translateY(0)'}],{duration:900,easing:'cubic-bezier(.2,.7,.2,1)'});observer.disconnect();} },{threshold:.15});
     observer.observe(el);
   });
   const nav=document.querySelector('.ad-chapter-nav');
   if(nav&&!nav.dataset.ready){nav.dataset.ready='true';const links=[...nav.querySelectorAll('a')];const targets=links.map(a=>document.querySelector(a.getAttribute('href'))).filter(Boolean);if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{for(const entry of entries)if(entry.isIntersecting)links.forEach(a=>a.setAttribute('aria-current',String(a.hash==='#'+entry.target.id)));},{rootMargin:'-20% 0px -45% 0px'});targets.forEach(t=>observer.observe(t));}}
   progress();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
 document.addEventListener('shopify:section:load',e=>init(e.target));
})();
